import Request from './request'

const Dashboard = {
  dashboardIndex (callback) {
    Request.get('dashboard/index').then(callback).catch(this.bad_answer)
  },
  dashboardDeviceMap (url, callback) {
    Request.get(url).then(callback).catch(this.bad_answer)
  },
  dashboardDeviceTraffic (callback) {
    Request.get('dashboard/device-traffic').then(callback).catch(this.bad_answer)
  },
  dashboardStats (callback) {
    Request.get('dashboard/stats').then(callback).catch(this.bad_answer)
  },
}
export default Dashboard
